import React from "react";
import { useState } from "react";
// import logo from '../../assets/frontimg/logo.png'
import payments from "../../assets/frontimg/payments.png";
import "../../Style.css";
import { Link } from "react-router-dom";
import logo2 from "../../assets/images/mica.png";

const SiteFooter = () => {
    const [email, setEmail] = useState("")

    const handleTop = () => {
        // window.scrollTo(0, 0,);
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };
    return (
        <div>
            <footer id="site-footer" className="site-footer" style={{ backgroundColor: '#f8e9d5', color: '#333' }}>
                <div className="footer">
                    <div className="section-padding">
                        <div className="section-container">
                            <div className="block-widget-wrap">
                                <div className="row">
                                    <div className="col-lg-3 col-md-6">
                                        <div className="block block-image">
                                            <img
                                                width="100"
                                                src={logo2}
                                                alt="logo.png"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-6">
                                        <div className="block block-menu">
                                            <h2 className="block-title" style={{ color: '#333' }}>
                                                Contact Us
                                            </h2>
                                            <div className="block-content">
                                                <ul>
                                                    <li>
                                                        <a href="tel:8989000066" style={{ color: '#333' }}>
                                                            Mo.: +91 8989000066
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href="mailto:info@micasasucasa.in" style={{ color: '#333' }}>
                                                            info@micasasucasa.in
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-6">
                                        <div className="block block-menu">
                                            <h2 className="block-title" style={{ color: '#333' }}>
                                                Services
                                            </h2>
                                            <div className="block-content">
                                                <ul>
                                                    <li>
                                                        <Link to="/about" style={{ color: '#333' }}>
                                                            About US
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link to="/contact" style={{ color: '#333' }}>
                                                            Contact US
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link to="/terms" style={{ color: '#333' }}>
                                                            Terms & Conditions
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link to="/privacy" style={{ color: '#333' }}>
                                                            Privacy Policy
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link to="/shippingpolicy" style={{ color: '#333' }}>
                                                            Shipping Policy
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link to="/refund" style={{ color: '#333' }}>
                                                            Return & Refund
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link to="/sitefaq" style={{ color: '#333' }}>
                                                            FAQ
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link to="/imagegallery" style={{ color: '#333' }}>
                                                            Image Gallery
                                                        </Link>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-6">
                                        <div className="block block-newsletter">
                                            <h2 className="block-title" style={{ color: '#333' }}>
                                                Newsletter
                                            </h2>
                                            <div className="block-content">
                                                <div className="newsletter-text" style={{ color: '#333' }}>
                                                    Enter your email below to be
                                                    the first to know about new
                                                    collections and product
                                                    launches.
                                                </div>
                                                <form
                                                    action=""
                                                    method="post"
                                                    className="newsletter-form"
                                                >
                                                    <input
                                                        type="email"
                                                        name="your-email"
                                                        value={email}
                                                        onChange={(e)=>setEmail(e.target.value)}
                                                        size="40"
                                                        placeholder="Email address"
                                                        style={{ backgroundColor: '#E8E8E8', border: '1px solid #666' }}
                                                    />
                                                    <span className="btn-submit">
                                                        <input
                                                            type="submit"
                                                            value="Subscribe"
                                                            style={{ backgroundColor: '#666', color: 'white' }}
                                                        />
                                                    </span>
                                                </form>
                                            </div>
                                        </div>

                                        <div className="block block-image">
                                            <img
                                                width="400"
                                                height="79"
                                                src={payments}
                                                alt=""
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="back-top button-show" onClick={handleTop} style={{ backgroundColor: '#666', color: 'white' }}>
                    <i class="arrow_carrot-up"></i>
                </div>

                <div className="footer-bottom" style={{ backgroundColor: '#f8e9d5', borderTop: '1px solid #666' }}>
                    <div className="section-padding">
                        <div className="section-container">
                            <div className="block-widget-wrap">
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="footer-left">
                                            <div className="social-links">
                                                <ul className="social-link" style={{ display: 'flex', justifyContent: 'flex-start', gap: '20px', listStyle: 'none', padding: 0 }}>
                                                    <li>
                                                        <a href="mailto:info@micasasucasa.in" style={{ color: '#333' }}>
                                                            <i className="fa fa-envelope"></i>
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href="http://instagram.com/_u/micasasucasa.in/" style={{ color: '#333' }}>
                                                            <i className="fa fa-instagram"></i>
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href="#" style={{ color: '#333' }}>
                                                            <i className="fa fa-dribbble"></i>
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href="#" style={{ color: '#333' }}>
                                                            <i className="fa fa-behance"></i>
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="text-center mt-3">
                                    <p className="copyright" style={{ 
                                        color: '#000000',
                                        textShadow: `
                                            0 0 1px #fff,
                                            0 0 2px #fff,
                                            0 0 3px rgba(255,255,255,0.8)
                                        `,
                                        fontSize: '15px',
                                        margin: 0,
                                        fontWeight: '600',
                                        letterSpacing: '1.2px',
                                        padding: '10px 0'
                                    }}>
                                        © Developed by Urvish Joshi. 2025 MicasaSucasa. All rights reserved.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    );
};

export default SiteFooter;
